// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kz-0";